import { name } from "file-loader"

export default {
    // 常规，全局 ， 弹框、 提示、警告等
    CommonObject:{
        greeting: '欢迎来到汉神课堂！',
        shopgreeting:"订单满 SGD50 免邮费!",
        title: '汉神课堂',
        tipTitle:'提示',
        warnTitle:'警告',
        ok:'好的',
        sendEmail:'发送邮件',
        back:'返回',
        exit:'退出',
        cancel:'取消',
        close:'关闭',
        confirm:'确定',
        submit:'提交',
        success:'操作成功',

        fail:'操作失败',
        retry:"重试",
        delete:'删除',
        remove:'移除',
        save:'保存',
        eidt:'编辑',
        saving:'正在保存，请稍后',


        tomuch:'操作过于频繁，请30秒后再试!',
        tomuchone:'操作过于频繁，请5分钟后再试!',
        // 没有数据
        emptyData: '这里什么都没有~',

        // 获取失败
        failtoget: '数据获取失败',

        moduleDeveloping:'此模块正在建设中，敬请期待...',

        companyAddress:'地址',
        serviceCenterAddress:'客服中心地址',
        newsLetter:'订阅我们的消息',
        join:"订阅"
    },

    // 通用登录
    LoginCommon:{
        unlogin:'未登录',
        unloginTip: '需要先登录',
        tologin:'去登录',
        uncheckEmail:'邮箱未验证',
        emailuncheckTip: '您的邮箱未验证哦~，不能兑换商品。请到个人中心验证邮箱',
        tokenExpire :'用户未登录,或者登录已过期，请重新登录!',

        orderQuery:'历史订单'
    },

    // 登录
    LoginObject: {
        name:'登录',
        title:'欢迎登录',
        accountPlaceHolder:'请输入账号/邮箱',
        passwordPlaceHolder: '请输入密码',
        accountRequire:'账号不能为空！',
        passwordRequire:'密码不能为空！',
        remember:'记住登录状态',
        forget:'忘记密码？',

        // 登录结果
        success: '登录成功',
        fail: '登录失败',
        error:'登录出错',

        // 账号状态
        passwordLimit:'密码至少包含6位数',
        accountExpir:'您的账号将在',
        accountEnd:'到期',
        accountExpired:'您的账号已过期！',
        accountExpirsubfix:'，请联系管理员续期，或者到积分兑换中心兑换试用期。',

        // 重置密码
        resetTitle:'重置密码',
        emailPlaceHolder:'请输入验证邮箱',
        emailInvalidate:'邮箱格式不正确',
        nickNamePlaceHolder:'请输入账号昵称',
        emailTips:'修改密码的链接将发送至邮箱，请点击链接修改密码.',
        emailSend:'邮件已发送',
    },
    // 账号中心
    AccountCenterObject:{
        accountCenter:'个人中心',
        pointsRecord:'积分记录',
        exchangeRecord:'兑换记录',
        matchRecord:'我的比赛',
        orderRecord:'我的订单',
        logout:'退出账号',
        logoutTip: '确定要退出账号吗？',

        // 个人中心
        changeAvtar:'更换头像',
        infoBand:'信息绑定',
        email:'邮箱',
        points:'积分',
        changeEmail:'修改邮箱',
        checkEmail:'验证邮箱',
        changePassword:'修改密码',
        infoTitle:'个人信息',

        userName: '姓名',
        sex: '性别',
        sexMale:'男',
        sexFemale:'女',
        phone:'手机',
        school:'学校',
        grade:'年级',
        gradeHolder: '请选择年级',
        eidt:'编辑',
        save:'保存',

        changeEmailTip: '我们将向以下邮箱发送验证邮件，点击邮箱的链接即可验证。',
        sendEmail:'发送验证邮件',

        sameAsBefore:'和原来的一样',

        phoneInput: '请输入新的手机号码',
        phoneTitle:'修改手机号',
        invalidPhone:'手机号码不正确',

        sendFirst:'请先发送验证邮件',
        checkEmailContent: '请查看邮箱，并按邮箱内容验证',

        imageTypeCheck:'上传图片只能是 JPG、JPEG 或 PNG 格式!',
        imageLimit: '图片大小不能大于2M',

        checking:'检验中',
        checkSuccess:'校验成功',
        checkFail:'校验失败',

        changePasswordbofore: '需要绑定邮箱才能修改密码哦',
        willSendEmail:'即将向以下邮箱发送验证邮件，请根据邮件内容操作。'
    },

    // 积分记录
    PointRecordObject:{
        name:'积分记录',
        type:'类型',
        score:'积分',
        index:'索引',
        createTime:'时间',

        typegame:'打字游戏',
        dicGame:'词典比赛'

    },


    // 首页
    HomeObject:{
        name:'首页',
        hot:'热门活动',
        myscore: '我的成绩',
        more:'更多',
        niceShop:'好物商城'
    },

    // 打字比赛
    TypingObject:{
        name:'打字比赛',
        practice:'打字练习',
        

    },
    FreetrialObject:{
        name: 'JoyReader 试用',
    },
    // 打字游戏、 词典游戏  公共的
    GameObject:{
        instatistics: '比赛数据统计中，请稍后查看~',
        signSuccess:'报名成功，等待比赛开始',
        signFail:'报名失败',
        finish:'比赛已完成',
        seeinaccount: '可在“个人中心”-> “我的比赛”中查看详情哦~',
        signNow: '现在报名',
        noSign:'你还没报名该比赛哦~',
        unlock:'解锁',
        unlockfail:'解锁失败',
        unlocksuccess:'解锁成功',
        unlockenough:'解锁积分不足',
        notunlock:'课程未解锁',
        needPoints:'解锁课程需要积分：',
        unlockPoints:'积分',

        // 练习进行时：
        overView:'统计',
        wordLabel:'字数',
        levelLabel:'等级',
        correctLabel: '正确',
        errorLabel:'错误',
        speedLabel: '速度',
        speedUnit:'字/分钟',
        leftLabel:'剩余',
        costTimeLabel:'用时',
        minutes:'分钟',

        placeHodler: '请输入内容',
        tipText:'提示一下',
        hideTip:'关闭提示',
        finishText:'退出',
        over:'结束',
        submitText:'交卷',

        levelEasy:'初级',
        levelNormal:'中级',
        levelHard:'高级',
        levelUnknown:'未知',

        dataLost:'答案信息将丢失',
        timeCountingdown:'考试时间到了，即将自动提交答卷！',

        commitMulti:'已经提交过了，请勿重复提交',
        commitError:'提交失败',
        commitSuccess:'提交成功',

        timeCounting:'倒计时',
        gameTime: '比赛限时',
        start:'开始比赛',

        scoreLabel:'成绩',
        pointsLabel:'积分',

    },  
    // 词典比赛
    DictionaryObject:{
        name:'词典比赛',
        practice:'词典练习',

        enterYourAnswer:'请在这里输入你的答案',
        yourAnswer:'你的答案',
        correctAnswer:'正确答案',
        analysis:'解析',
        next:'下一题',
        before:'上一题',

        timeLeft:'时间剩余',
        timeCost:'已用时',
        submitPaper:'交卷',
        finish:'完成',
        minutes:'分钟',
        score:'成绩',
        points:'积分',

        //答案模式
        totalScore:'总分',
        unit:'分',
        questions:'题量',
        undo:'未答',
        done:'已答',
        correct:'答对',
        error:'答错',
        mcq:'选择题',
        cloze:'填空题',
        level:'难度等级',




    },

    // 成绩排行
    RankingObject:{
        name:'我的成绩',
        noData:'暂无积分记录',
        myself:'我的排名'
    },
    // 积分商城
    PointShopObject :{
        name:'积分商城',
        title:'积分兑换',
        exchangedNum:'人已兑换',
        exchangedPer:'已兑',
        exchange:'立即兑换',

        willCost: '您即将花费',
        pointCount: '积分兑换',

        fillinfo:'请完成以下信息进行兑换',
        consignee:'收件人',
        phone:'联系电话',
        email:'邮箱',
        address:'收件地址',
        loginPassword:'登录密码',

        consigneeRequire:'收件人必填',
        phoneRequire:'联系电话必填',
        emailRequire:'邮箱必填',
        addressRequire:'地址必填',
        loginPasswordRequire:'登录密码必填',

        pointNoUnough: '您的积分不足，不能兑换商品哦~',

        exchangeSuccess:'兑换成功，可在“个人中心”->“兑换记录”中查看详情哦~',

    },

    // 商城
    ShopObject:{
        name:'商城',
        category:'商品分类',
        settlement:'结算',
        outofstock:'已售罄',

        packing:'包装清单',
        level:'请选择年级',
        quantity:'数量',
        weight:'产品规格',
        dimensions:'尺寸',
        addToCart:'加入购物车',

        download:'文件下载',

        shoppingCart:'购物车',
        productImage:'商品图片',
        productName:'商品',
        price:'单价',
        totalPrice:'总价',
        action:'操作',

        subtotal:'总共',
        submary:'统计',
        placeOrder:'去结算',

        expire: '已过期',
        soldout: '售罄',

        removeTip: '确定要从购物车移除该商品吗？',
        invalidTip: '购物车中包含已失效或者已过期商品，请先删除',

        //支付信息
        checkOut: '支付信息',
        shippingInfo:'邮寄信息',
        country:'国家/地区',
        shippingMethod:'邮寄方式',
        shippAddress:'邮寄地址',
        postCode:'邮政编码',

        paymentInfo:'付款信息',
        firstName:'名字',
        lastName:'姓氏',
        email:'邮箱',
        phone:'电话',

        shoppingInfo:'购物信息',

        shippingFee:'邮费',
        shippingFeeTip:'订单满',
        shippingFeeTipsub:'免邮费！',
        topay: '去下单',

        //付款信息
        countryRequire:"请选择地区/国家",
        addressRequire:"请输入邮寄地址",
        postcodeRequire:"请输入邮寄编码",
        firstNameRequire:"请输入名字",
        lastNameRequire:"请输入姓氏",
        phoneRequire:"请输入手机号码",

        emailRequire:'请输入邮箱',
        invalidEmail:'邮箱格式不正确',

        paymentInfoRequire: '付款信息必填项未填写',
        shippingInfoRequire: '邮寄信息必填项未填写',
        purchaseLimit: '限购',

        useCoupon:'使用优惠卷',
        invalidCoupon:'无效的优惠卷',
        expirCoupon: '优惠卷已过期或者未到使用时间',
        usedCoupon:'优惠卷已被使用',
        couponTip:'优惠卷和折扣价同时存在时，将以较低价格计算总价。',
        couponCheck: '校验',
        couponChange:'修改',
        pleaseInput:'请输入优惠卷码',
        checkTip:'优惠卷校验成功，不代表优惠卷已经被使用。',

        fileName:'文件名',
        download:'下载',
        operation:'操作',
        video:'视频'
    },

    OrderObject:{
        detail:'订单详情',
        subTotal:'订单总价',
        includingFee: '包含邮费',

        waitPay:'去支付',
        paied:'已支付',
        ack:'确认收货',
        signed:'已签收',

        originalPrice:'原价',
        discount:'折扣价',

        signedTip: '确定已经收到商品了吗？',

        waitPaying:'支付页面跳转中，请稍后。如果没有跳转，请点击“好的”按钮',

        waitingForPay:'等待支付结果...',
        paySuccess:'支付成功',
        payFail:'支付失败',
        payCancel:'支付取消',
        payTimeout:'支付超时',
        autoClose:'页面即将自动关闭',

        // OrderItem
        orderId:'订单编号',
        totalGoods:'件商品',
        orderTime:'下单时间',
        detail:'订单详情',

        itemWaitPay:'待支付',
        itemPaied:'已支付',
        itemAck:'已发货',
        itemSigned:'已签收',

        // 详情问候
        orderTitle:"感谢您选择我们的产品",
        orderdone:'支付成功!',
        greet:"您好",
        receiveYourOrder:"我们已经收到你的订单：",
        thank:"非常感谢您选择我们的产品！",
        sendYouEmail:"我们将会给您发送一封确认邮件。",
        pleaseContactUs:"如果您有需要，请及时与我们联系！",
        success:"恭喜您！订单",
        succsssubfix:"已完成",
        payTime:"付款时间",
        payMount:"付款金额",
        
        myPayTip:"非常感谢您选择我们的产品！",
        myPaySubs:"完成订单还需要以下步骤:",
        myPayStep1:"1.使用银行应用程序扫描二维码，或PayNow到UEN# 201625979C。",
        myPayStep2:"2.输入您的订单号作为银行参考依据。",
        myPayStep3:"3.订购确认书将于下一个工作天发出。",
        myPayStepOrderNum:"订单号:"

    },

    // 兑换记录
    ExchangeObject:{
        name:'兑换记录',
        tabAll:"全部",
        tabWaitShipping:"待发货",
        tabWaitSign:"待签收",

        received:'确认签收',
        tabSign:"已完成",

        index:'序号',
        pruduct:'商品',
        addressInfo:'收货信息',
        points:'积分',
        status:'状态',
        update: '更新时间'
    },

    MyGameObject:{
        name:'我的比赛',
        typingGame:'打字比赛',
        dictGame:'词典比赛',
        gameTime:'比赛时间',
        untitle:'无标题',
        unknown:'未知',
        score: '分数',
        detail:'详情',
        tostart:'待开始',
        signup:'已报名',
        gaming:'进行中',
        submary:'统计中',

        gameOverTip:'比赛已经结束，您没有提交答案哦~',
        inGameTip :'当前比赛进行中，点击确认立即开始',
        gameSubmaring:'比赛数据统计中，请稍后查看',
        gameNoStart :'比赛尚未开始哦~',

    },

    // 保修登记
    WarrantyObject:{
        name:'保修注册',
        title: '保修卡',
        userName:'姓名',
        email:'邮箱',
        phone:'联系电话',
        purchaseDate:'购买日期',
        purchaseProduct:'购买产品',
        purchasePlace:'购买地址',
        serialCode:'序列号',
        datePlaceHolder:'请选择购买日期',
        nameRequire:'请输入名字',
        emailRequire:'请输入邮箱',
        palceReuqire:'请输入购买地址',
        productRequire:'请选择产品',
        codeRequire:'请输入产品序列号',
        requireTip:'必填项。',
        productWarranty:'在这里打勾表示您已经阅读并理解了',
        warrantItems:'保修条款',
        fail:'请仔细阅读保修条款！'
       
    },
    // 游戏中心
    GameCenterObject:{
        name:'游戏中心',
        gamePlane:'飞机大战',
        gameRace:'龟兔赛跑',
        gameBee:'蜜蜂采蜜',
    },

    HelpObject:{
        name:'帮助',
        contactUs:'联系我们',
        locateUs:'找到我们',
        faq:'FAQ',
        contactDetail:'联系详情',
        serviceCenter:'客服中心',
        serviceSub:'A Genuine Technology',
        address:'地址',
        pohne:'联系电话',
        workTime:'工作时间',
        week:'周一至周六',
        weekday:'周一至周五'

    },

    // 关于我们
    AboutObject:{
        name:'关于我们',
        part1: '创而新（新加坡）教育科技有限公司开始于新加坡创新科技有限公司，是创新科技属下中文软件部，专注数字教育领域20多年。',
        part2: '现今总部设在北京的创而新（北京）教育科技有限公司，为创而新科技教育集团的领头羊，她继承了创新科技“以科技创造新生活”的价值基因和深厚的技术积累，在自然语言处理、语音辨识科技、在线语言测评模型、教育互动技术等方面取得新突破，拥有超过80项专利与软件著作权。',
        part3: '公司将科技与出版融合，创新数字资源建设方式，不断升级数字教材和数字阅读产品的形态和开发模式；以科技服务教育，促进新型教育模式构建，逐步完善了数字绘本阅读等产品解决方案，构建了数字化教科书和数字化课堂的应用模型，积累了网络教育平台开发和运营方面的丰富经验和成熟模式。',
        part4: '创而新（新加坡）教育科技有限公司，负责将产品及方案推展到东南亚各地，与本地区合作伙伴配合，将产品与技术因应本地要求在地化，获得用户的信赖和喜爱。'
    },

    PromotionObject:{
        tip:'输入口令进入活动页面',
        enterCode:'请输入口令',
        
        wait:'请稍后',
        ok:'确定',
        noStart :'活动未开始',
        over: '活动已结束',
        time:'活动时间',
        beforeStart: '距离活动开始还有：',
        beforeEnd:'距离活动结束剩余：'
    },

    // 联系方式
    ContactObject: {

    }


}


// WEBPACK FOOTER //
// ./src/lang/zh.js